<template>
    <page title="偏远查询">
        <div>
            <div class="form remote" style="padding-top: 20px;" v-show="formShow">
                <mt-field label="目的地" placeholder="选择目的地" v-model="search.countryName" readonly
                          @click.native="openDestination">
                    <img v-if="search.countryName" src="../assets/locationh.png" alt="" class="input-icon2">
                    <img v-else src="../assets/location.png" alt="" class="input-icon2">
                </mt-field>
                <mt-field label="路线大类" placeholder="选择路线大类" readonly v-model="search.remoteType"
                          @click.native="popupVisible=true">
                    <img v-if="search.remoteType" src="../assets/typeh.png" alt="" class="input-icon2">
                    <img v-else src="../assets/type.png" alt="" class="input-icon2">
                </mt-field>
                <mt-field label="邮编" placeholder="输入目的地邮编" v-model.trim="search.postCode">
                    <img v-if="search.postCode" src="../assets/postcodeh.png" alt="" class="input-icon">
                    <img v-else src="../assets/postcode.png" alt="" class="input-icon">
                </mt-field>
                <mt-field label="城市" placeholder="输入目的地城市" v-model.trim="search.city">
                    <img v-if="search.city" src="../assets/cityh.png" alt="" class="input-icon">
                    <img v-else src="../assets/city.png" alt="" class="input-icon">
                </mt-field>
            </div>
            <div class="padded mt-gap2">
                <mt-button type="primary" style="width: 100%;" @click="searchData()">查询</mt-button>
            </div>
            <div style="background: #fff;margin-top: 20px;" v-show="initSearch">
                <p class="search-title">查询条件</p>
                <div class="search-list">
                    <span>目的地：{{search.countryName}}</span>
                    <span>大类：{{search.remoteType}}</span>
                    <span>邮编：{{search.postCode}}</span>
                    <span>城市：{{search.city}}</span>
                </div>
            </div>
            <div v-if="initSearch&&result.length===0">
                <p style="text-align: center;margin-top: 10px;color: #999;font-size: 14px;">没有数据</p>
            </div>
            <div
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="loading"
                    infinite-scroll-immediate-check="false"
                    infinite-scroll-distance="10">
                <div style="background: #fff;margin-top: 20px;padding: 0 10px;">
                    <div style="padding: 10px 0;">
                        <div v-for="(item,index) in result" :key="index" style="font-weight: bold;font-size:14px">
                            <div>
                            <span>{{item.remoteType}}：</span>
                            <span :style="item.isRemote == '1' ? 'color:red;' :''"><span v-if="item.isRemote == '1'">邮编是偏远</span><span v-else>邮编不是偏远</span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <mt-popup
                    style="width: 100%;"
                    v-model="popupVisible"
                    position="bottom">
                <div style="background: #fff;height: 240px;width: 100%;">
                    <div style="padding: 10px;">
                        <mt-button size="small" type="default" style="float: left;" @click="popupVisible=false">取消
                        </mt-button>
                        <mt-button size="small" type="primary" style="float: right;" @click="typeConfirm()">确定
                        </mt-button>
                    </div>
                    <mt-picker :slots="types" @change="onValuesChange"></mt-picker>
                </div>
            </mt-popup>

            <oms-destination ref="omsDestination" @getCountryCode="getDestNo"></oms-destination>
        </div>
    </page>
</template>
<script>
    import omsDestination from '@/components/omsDestination'

    export default {
        components: {
            omsDestination
        },
        created() {
            document.title = "偏远查询";
        },
        data() {
            return {
                popupVisible: false,
                destExtendedType: '',
                initSearch: false,
                formShow: true,
                search: {
                    pageIndex: 1,
                    pageSize: 100,
                    remoteType: '',
                    city: '',
                    postCode: '',
                    destNo: ''
                },
                types: [
                    {content: 'type1', values: ['UPS', 'DHL', 'TNT', 'FED',]},
                ],
                result: [],
                total: '',
            }
        },
        methods: {
            onValuesChange(obj) {
                this.destExtendedType = obj.values[0];
            },
            openDestination() {
                this.formShow = false;
                this.$refs.omsDestination.open();
            },
            getDestNo(res) {
                this.formShow = true;
                this.$set(this.search, 'countryName', res.name);
                this.$set(this.search, 'destNo', res.code);
            },
            typeConfirm() {
                this.search.remoteType = this.destExtendedType;
                this.popupVisible = false;
            },
            searchData() {
                if (this.loading) return false;
                if (!this.search.destNo) {
                    this.$toast("请选择目的地");
                    return;
                }
                this.initSearch = true;
                this.result = [];
                this.getData();
            },
            getData(pageIndex = 1, pageSize = 10) {
                if (!this.search.destNo) {
                    this.$toast("请选择目的地");
                    return;
                }
                this.loading = true;
                this.$indicator.open({
                    spinnerType: 'fading-circle'
                });
                this.search.pageIndex = parseInt(pageIndex);
                this.search.pageSize = parseInt(pageSize);
                this.http.send({command: 'remoteDest/selectRemoteDest', params: this.search}).then(res => {
                    this.loading = false;
                    this.$indicator.close();
                    // this.total = res.data.body.count;
                    // this.result = this.result.concat(res.data.body.datas || []);
                    this.result = res.data.body.datas || [];
                }).catch(err => {
                    this.loading = false;
                    this.$indicator.close();
                });
                let companyNo = this.$util.get('companyNo');
                this.http.send({
                    command: 'destCountry/putSelectCountry',
                    params: {companyNo: companyNo, purposeCode: this.search.destNo}
                }).then(res => {
                })
            },
            loadMore() {
                if (this.loading) return false;
                if (this.total === this.result.length) return false;
                this.search.pageIndex++;
                this.getData(this.search.pageIndex);
            }
        }
    }
</script>
<style scoped>
    .remote >>> .mint-field-core {
        text-align: right;
    }
</style>
<style lang="less" scoped>
    .search-title {
        padding-top: 10px;
        text-align: center;
        color: #333;
        font-size: 16px;
    }
    .search-list {
        padding: 10px 10px 20px;
        span {
            font-size: 12px;
            color: #333;
            background: #f5f5f5;
            padding: 6px 8px;
            border-radius: 4px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/remote.vue